/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.8
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrganizationTraitsSetDTO } from './OrganizationTraitsSetDTO';
import {
    OrganizationTraitsSetDTOFromJSON,
    OrganizationTraitsSetDTOFromJSONTyped,
    OrganizationTraitsSetDTOToJSON,
} from './OrganizationTraitsSetDTO';
import type { AvatarSourceEnum } from './AvatarSourceEnum';
import {
    AvatarSourceEnumFromJSON,
    AvatarSourceEnumFromJSONTyped,
    AvatarSourceEnumToJSON,
} from './AvatarSourceEnum';
import type { PricingPlanDefinitionDTO } from './PricingPlanDefinitionDTO';
import {
    PricingPlanDefinitionDTOFromJSON,
    PricingPlanDefinitionDTOFromJSONTyped,
    PricingPlanDefinitionDTOToJSON,
} from './PricingPlanDefinitionDTO';
import type { OrganizationTypeDTO } from './OrganizationTypeDTO';
import {
    OrganizationTypeDTOFromJSON,
    OrganizationTypeDTOFromJSONTyped,
    OrganizationTypeDTOToJSON,
} from './OrganizationTypeDTO';
import type { PricingPlanDTO } from './PricingPlanDTO';
import {
    PricingPlanDTOFromJSON,
    PricingPlanDTOFromJSONTyped,
    PricingPlanDTOToJSON,
} from './PricingPlanDTO';

/**
 * 
 * @export
 * @interface OrganizationDTO
 */
export interface OrganizationDTO {
    /**
     * 
     * @type {string}
     * @memberof OrganizationDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDTO
     */
    name: string;
    /**
     * 
     * @type {Date}
     * @memberof OrganizationDTO
     */
    created: Date;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDTO
     */
    paymentStatus: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDTO
     */
    info?: string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDTO
     */
    avatarUrl: string;
    /**
     * 
     * @type {AvatarSourceEnum}
     * @memberof OrganizationDTO
     */
    avatarSource: AvatarSourceEnum;
    /**
     * 
     * @type {OrganizationTypeDTO}
     * @memberof OrganizationDTO
     */
    organizationType: OrganizationTypeDTO;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationDTO
     */
    limitsEnforced: boolean;
    /**
     * 
     * @type {PricingPlanDTO}
     * @memberof OrganizationDTO
     */
    pricingPlan: PricingPlanDTO;
    /**
     * 
     * @type {PricingPlanDefinitionDTO}
     * @memberof OrganizationDTO
     */
    pricingPlanDefinition: PricingPlanDefinitionDTO;
    /**
     * 
     * @type {boolean}
     * @memberof OrganizationDTO
     */
    supportsMonitoringHoursLimits: boolean;
    /**
     * 
     * @type {OrganizationTraitsSetDTO}
     * @memberof OrganizationDTO
     */
    traits: OrganizationTraitsSetDTO;
    /**
     * 
     * @type {string}
     * @memberof OrganizationDTO
     */
    userflowIdentityHash: string;
}



/**
 * Check if a given object implements the OrganizationDTO interface.
 */
export function instanceOfOrganizationDTO(value: object): value is OrganizationDTO {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('created' in value) || value['created'] === undefined) return false;
    if (!('paymentStatus' in value) || value['paymentStatus'] === undefined) return false;
    if (!('avatarUrl' in value) || value['avatarUrl'] === undefined) return false;
    if (!('avatarSource' in value) || value['avatarSource'] === undefined) return false;
    if (!('organizationType' in value) || value['organizationType'] === undefined) return false;
    if (!('limitsEnforced' in value) || value['limitsEnforced'] === undefined) return false;
    if (!('pricingPlan' in value) || value['pricingPlan'] === undefined) return false;
    if (!('pricingPlanDefinition' in value) || value['pricingPlanDefinition'] === undefined) return false;
    if (!('supportsMonitoringHoursLimits' in value) || value['supportsMonitoringHoursLimits'] === undefined) return false;
    if (!('traits' in value) || value['traits'] === undefined) return false;
    if (!('userflowIdentityHash' in value) || value['userflowIdentityHash'] === undefined) return false;
    return true;
}

export function OrganizationDTOFromJSON(json: any): OrganizationDTO {
    return OrganizationDTOFromJSONTyped(json, false);
}

export function OrganizationDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrganizationDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'created': (new Date(json['created'])),
        'paymentStatus': json['paymentStatus'],
        'info': json['info'] == null ? undefined : json['info'],
        'avatarUrl': json['avatarUrl'],
        'avatarSource': AvatarSourceEnumFromJSON(json['avatarSource']),
        'organizationType': OrganizationTypeDTOFromJSON(json['organizationType']),
        'limitsEnforced': json['limitsEnforced'],
        'pricingPlan': PricingPlanDTOFromJSON(json['pricingPlan']),
        'pricingPlanDefinition': PricingPlanDefinitionDTOFromJSON(json['pricingPlanDefinition']),
        'supportsMonitoringHoursLimits': json['supportsMonitoringHoursLimits'],
        'traits': OrganizationTraitsSetDTOFromJSON(json['traits']),
        'userflowIdentityHash': json['userflowIdentityHash'],
    };
}

export function OrganizationDTOToJSON(value?: OrganizationDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'created': ((value['created']).toISOString()),
        'paymentStatus': value['paymentStatus'],
        'info': value['info'],
        'avatarUrl': value['avatarUrl'],
        'avatarSource': AvatarSourceEnumToJSON(value['avatarSource']),
        'organizationType': OrganizationTypeDTOToJSON(value['organizationType']),
        'limitsEnforced': value['limitsEnforced'],
        'pricingPlan': PricingPlanDTOToJSON(value['pricingPlan']),
        'pricingPlanDefinition': PricingPlanDefinitionDTOToJSON(value['pricingPlanDefinition']),
        'supportsMonitoringHoursLimits': value['supportsMonitoringHoursLimits'],
        'traits': OrganizationTraitsSetDTOToJSON(value['traits']),
        'userflowIdentityHash': value['userflowIdentityHash'],
    };
}

